var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/components/background_shapes.tsx";
import classNames from 'classnames';
import React from 'react';
/** Gradient that appears in the background of the UI. */
const BackgroundShapes = ({
  position = 'fixed'
}) => /*#__PURE__*/React.createElement("div", {
  className: classNames(position, 'top-0 inset-x-0 flex justify-center overflow-hidden pointer-events-none'),
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 11,
    columnNumber: 3
  }
}, /*#__PURE__*/React.createElement("div", {
  className: "w-screen h-screen bg-gradient-sm lg:bg-gradient-lg",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 12,
    columnNumber: 5
  }
}));
export default BackgroundShapes;